import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ApiModule } from '@partners/api';

import { rootMetaReducers, rootReducers } from './root';
@NgModule({
  imports: [
    ApiModule,
    EffectsModule.forRoot([]),
    StoreModule.forRoot(rootReducers, {
      metaReducers: rootMetaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true
      }
    })
  ]
})
export class StateModule {}
